import React from "react";

const AddGeography = () => {
    return <div>AddGeography</div>;
};

export default AddGeography;
